/**
 * 移动端"更多"页面 - 快捷导航
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Card,
  List,
} from 'antd-mobile';
import {
  AppstoreOutline,
  ShopbagOutline,
  GiftOutline,
  FolderOutline,
  TagOutline,
  TeamOutline,
  MailOutline,
  SetOutline,
  PicturesOutline,
} from 'antd-mobile-icons';

export default function MobileMorePage() {
  const navigate = useNavigate();

  const menuItems = [
    { icon: <AppstoreOutline style={{ fontSize: 22, color: '#00d4aa' }} />, label: '库存管理', path: '/admin/m/inventory', desc: '查看和调整库存' },
    { icon: <ShopbagOutline style={{ fontSize: 22, color: '#ff7a45' }} />, label: '弃单管理', path: '/admin/m/abandoned-orders', desc: '恢复未完成订单' },
    { icon: <ShopbagOutline style={{ fontSize: 22, color: '#3b82f6' }} />, label: '最近购物车', path: '/admin/m/recent-carts', desc: '最近更新的购物车' },
    { icon: <GiftOutline style={{ fontSize: 22, color: '#faad14' }} />, label: '优惠码', path: '/admin/m/discounts', desc: '创建和管理折扣' },
    { icon: <FolderOutline style={{ fontSize: 22, color: '#1677ff' }} />, label: '分类管理', path: '/admin/m/categories', desc: '商品分类设置' },
    { icon: <TagOutline style={{ fontSize: 22, color: '#722ed1' }} />, label: '客户标签', path: '/admin/m/customer-tags', desc: '标记客户群体' },
    { icon: <TeamOutline style={{ fontSize: 22, color: '#13c2c2' }} />, label: '客户细分', path: '/admin/m/customer-segments', desc: '智能客户分组' },
    { icon: <MailOutline style={{ fontSize: 22, color: '#eb2f96' }} />, label: '邮件营销', path: '/admin/m/email-campaigns', desc: '批量邮件发送' },
    { icon: <PicturesOutline style={{ fontSize: 22, color: '#52c41a' }} />, label: '文件管理', path: '/admin/m/files', desc: '上传图片和 PDF' },
    { icon: <SetOutline style={{ fontSize: 22, color: '#595959' }} />, label: '系统设置', path: '/admin/m/settings', desc: '店铺基础配置' },
  ];

  return (
    <div style={{ minHeight: '100vh', background: '#f0f2f5', padding: 16 }}>
      <div style={{ marginBottom: 8, fontSize: 15, fontWeight: 600, color: '#1a1a2e' }}>
        快捷导航
      </div>

      <Card style={{ borderRadius: 12, overflow: 'hidden' }}>
        <List style={{ '--border-inner': 'none', '--border-top': 'none', '--border-bottom': 'none' }}>
          {menuItems.map((item) => (
            <List.Item
              key={item.path}
              prefix={item.icon}
              description={item.desc}
              onClick={() => navigate(item.path)}
              style={{
                padding: '14px 16px',
                background: '#fff',
              }}
            >
              <span style={{ fontSize: 15, fontWeight: 500, color: '#1a1a2e' }}>{item.label}</span>
            </List.Item>
          ))}
        </List>
      </Card>
    </div>
  );
}
